import React, { useState, useEffect, useLayoutEffect, useContext } from 'react'

import { NavigationContext } from '../../utility/index.js'

import './navigation.css'

export const Navigation = () => {
  const [items, setItems] = useState([])
  const [currentItem, setCurrentItem] = useState({ id: '', name: '' })
  const [isSticky, setIsSticky] = useState(false)
  const [isScrollingFromClick, setIsScrollingFromClick] = useState(0)

  const navigation = useContext(NavigationContext)

  let scrollTimeout

  useLayoutEffect(() => {
    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  })

  useEffect(() => {
    const _hasItems =
      navigation.navigationItems && navigation.navigationItems.length

    if (_hasItems) {
      setItems([...navigation.navigationItems])

      setCurrentItem(navigation.navigationItems[0])
    }
  }, [navigation])

  const onScroll = () => {
    const _isSticky = window.scrollY > 500

    setIsSticky(_isSticky)

    if (isScrollingFromClick) {
      clearTimeout(scrollTimeout)

      scrollTimeout = setTimeout(() => {
        setIsScrollingFromClick(0)

        doScroll()
      }, 100)
    } else {
      doScroll()
    }
  }

  const doScroll = () => {
    let _currentItem

    navigation.navigationItems.forEach((item) => {
      const _offsetTop = document.getElementById(item.id).offsetTop

      const _isCurrent = window.scrollY > _offsetTop - 300

      if (_isCurrent) {
        _currentItem = item
      }
    })

    if (_currentItem) {
      setCurrentItem(_currentItem)
    }
  }

  const onClickItem = (item) => {
    setCurrentItem(item)

    setIsScrollingFromClick(1)

    setTimeout(() => {
      const _scrollTo = document.getElementById(item.id).offsetTop + 40

      window.scroll({
        top: _scrollTo,
        left: 0,
        behavior: 'smooth',
      })
    }, 100)
  }

  return items.length ? (
    <div
      className={`${
        isSticky ? 'u-posFixed' : 'u-posAbsolute'
      } u-flex u-flexCol u-paddingTop12gu u-size1of4  u-sm-hidden`}
      style={{ top: isSticky ? 0 : 400 }}
    >
      <div>
        {navigation.navigationItems.map((item, index) => (
          <div
            key={index}
            className={`Link u-padding5gu u-textSizeMsrp1 u-textUppercase u-decoBorderLight ${
              index > 0 ? 'u-decoBorderResetTop' : ''
            } ${
              item.id === currentItem.id
                ? 'u-textColorBrand u-ls-borderLeft-selected'
                : 'u-textColorBlack'
            }`}
            onClick={() => onClickItem(item)}
          >
            {item.name}
          </div>
        ))}
      </div>
    </div>
  ) : null
}
